import type { IconData } from '@stacksjs/iconify-core'

export const mapLocationStarPinFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M4.5 21C4.5 10.23 13.23 1.5 24 1.5S43.5 10.23 43.5 21c0 6.987-3.606 12.865-7.526 17.203c-3.932 4.351-8.326 7.316-10.237 8.506a3.26 3.26 0 0 1-3.474 0c-1.91-1.19-6.305-4.155-10.237-8.506C8.106 33.865 4.5 27.987 4.5 21\"/><path fill=\"#2859c5\" d=\"M21.78 11.193c.933-1.799 3.506-1.799 4.44 0l2.044 3.941l4.377.862c1.904.375 2.673 2.682 1.376 4.125l-3.133 3.484l.572 4.635c.244 1.98-1.813 3.434-3.598 2.543L24 28.857l-3.859 1.926c-1.784.89-3.842-.564-3.597-2.543l.572-4.635l-3.133-3.484c-1.297-1.443-.528-3.75 1.376-4.125l4.377-.862z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mapLocationStarPinFlat
